const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = {
  // Messages
  async getMessages(token) {
    const response = await fetch(`${API_URL}/messages`, {
      headers: { 
        'x-auth-token': token,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    
    return response.json();
  },

  async createMessage(data) {
    const response = await fetch(`${API_URL}/messages`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    
    return response.json();
  },

  async markAsRead(id, token) {
    const response = await fetch(`${API_URL}/messages/${id}/read`, {
      method: 'PUT',
      headers: { 
        'x-auth-token': token,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    
    return response.json();
  },

  async deleteMessage(id, token) {
    const response = await fetch(`${API_URL}/messages/${id}`, {
      method: 'DELETE',
      headers: { 'x-auth-token': token }
    });
    
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    
    return response.json();
  },

  // Auth
  async login(username, password) {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Erro na autenticação');
    }
    
    return data;
  },

  async verifyToken(token) {
    const response = await fetch(`${API_URL}/auth/verify`, {
      headers: { 'x-auth-token': token }
    });
    
    if (!response.ok) {
      throw new Error('Token inválido');
    }
    
    return response.json();
  }
};

export default api;
